import { reactive } from 'vue'
import { FilterStore } from './filter-store'
import { SummaryDimension } from 'services/api-service'

/**
 * Place to store mutable state pertaining to reviews.
 */

// toolbar including sort, search, and filters
export const MIN_REVIEWS_FOR_TOOLBAR = 3

/**
 * Interface for the state property inside the store
 */
export interface IReviewsStoreState {
  filterStore: FilterStore
  sort: string
  searchTerm: string
  trimmedSearchTerm: string
  updateAriaText: boolean
}

const DEFAULT_STATE = JSON.stringify({
  filterStore: undefined,
  sort: undefined,
  searchTerm: '',
  trimmedSearchTerm: '',
  updateAriaText: false
})

export class ReviewsStore {
  constructor() {
    this.state.filterStore = new FilterStore()
  }

  state: IReviewsStoreState = reactive(JSON.parse(DEFAULT_STATE))

  // intended to be used from Reviews Summary where a single filter is selected (rating or dim)
  // that clears out any existing filtering first
  applySingleFilter(group: string, name: string, value: unknown, dim: SummaryDimension): void {
    const filter = this.filterStore.findOrAddFilter(group, name, dim)
    this.filterStore.clearFilters()
    this.filterStore.setFilterValue(filter, [value])
    this.searchTerm = ''
  }

  get filterStore(): FilterStore {
    return this.state.filterStore
  }

  set sort(sort: string) {
    this.state.sort = sort
  }

  get sort(): string {
    return this.state.sort
  }

  set searchTerm(searchTerm: string) {
    this.state.searchTerm = searchTerm
    this.state.trimmedSearchTerm = searchTerm.trim()
  }

  get searchTerm(): string {
    return this.state.searchTerm
  }

  get trimmedSearchTerm(): string {
    return this.state.trimmedSearchTerm
  }

  set updateAriaText(updateAriaText: boolean) {
    this.state.updateAriaText = updateAriaText
  }

  get updateAriaText(): boolean {
    return this.state.updateAriaText
  }

  // intended for testing
  reset(): void {
    const defaultState = JSON.parse(DEFAULT_STATE)
    Object.keys(this.state).forEach((k) => {
      this.state[k] = k === 'filterStore' ? new FilterStore() : defaultState[k]
    })
  }
}

export default new ReviewsStore()
